import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Affiliate } from 'types'

type InitialState = {
  schedulePhotoUrl?: string
  gymLogoUrl?: string
  primaryPhotoUrl?: string
  galleryPhotos?: { url?: string; order?: number }[]
}

const initialState: InitialState = {
  schedulePhotoUrl: null,
  gymLogoUrl: null,
  primaryPhotoUrl: null,
  galleryPhotos: [],
}

export const photosSlice = createSlice({
  name: 'photos',
  initialState: initialState,
  reducers: {
    updateSchedulePhoto: (state, action: PayloadAction<string>) => {
      state.schedulePhotoUrl = action.payload

      return state
    },
    updateLogoPhoto: (state, action: PayloadAction<string>) => {
      state.gymLogoUrl = action.payload

      return state
    },
    updatePrimaryPhoto: (state, action: PayloadAction<string>) => {
      state.primaryPhotoUrl = action.payload

      return state
    },
    updateGalleryPhotos: (
      state,
      action: PayloadAction<{ url?: string; order?: number }[]>,
    ) => {
      state.galleryPhotos = action.payload

      return state
    },
    updateAll: (state, action: PayloadAction<Affiliate>) => {
      state.primaryPhotoUrl = action.payload.images?.primary?.url
      state.gymLogoUrl = action.payload.images?.logo?.url
      state.galleryPhotos = action.payload.images?.gallery.map(
        (image, index) => {
          return { order: index, url: image.url }
        },
      )
      state.schedulePhotoUrl = action.payload.images?.schedule?.url
    },
  },
})

export const {
  updateSchedulePhoto,
  updatePrimaryPhoto,
  updateLogoPhoto,
  updateGalleryPhotos,
  updateAll,
} = photosSlice.actions

export default photosSlice.reducer
